const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const CONSENT_KEY = 'bb_cookie_consent'; // 'accepted' | 'declined'

let gaLoaded = false;

const loadGaScript = () => {
  if (gaLoaded || !GA_ID) return;
  gaLoaded = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID, { send_page_view: false }); // we fire pageviews manually for SPA tab changes
};

export const getConsent = () => localStorage.getItem(CONSENT_KEY);

export const setConsent = (value) => {
  localStorage.setItem(CONSENT_KEY, value);
  if (value === 'accepted') {
    loadGaScript();
  }
};

// Call once on app load - resumes tracking if the person already consented
// in a previous session
export const initAnalyticsIfConsented = () => {
  if (getConsent() === 'accepted') {
    loadGaScript();
  }
};

export const trackPageview = (path) => {
  if (getConsent() !== 'accepted' || !window.gtag) return;
  window.gtag('event', 'page_view', { page_path: path });
};

export const trackEvent = (name, params = {}) => {
  if (getConsent() !== 'accepted' || !window.gtag) return;
  window.gtag('event', name, params);
};
